<template>
  <section class="gold-tab-guide" :aria-label="guide.title + '说明'">
    <div class="gold-tab-guide__copy">
      <strong>{{ guide.title }}</strong>
      <span>{{ guide.summary }}</span>
    </div>
    <div class="gold-tab-guide__flow" role="list" :aria-label="guide.title + '主流程'">
      <template v-for="(step, index) in guide.flow || []" :key="step">
        <span role="listitem">{{ step }}</span>
        <el-icon v-if="index < guide.flow.length - 1"><ArrowRight /></el-icon>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GoldTabGuide',
  props: {
    guide: { type: Object, required: true }
  }
}
</script>

<style scoped>
.gold-tab-guide{display:flex;align-items:center;justify-content:space-between;gap:18px;margin:12px 0 14px;padding:13px 16px;border:1px solid var(--el-color-primary-light-7);border-radius:6px;background:var(--el-color-primary-light-9)}
.gold-tab-guide__copy{display:flex;flex-direction:column;gap:4px;min-width:220px}.gold-tab-guide__copy strong{font-size:14px;color:var(--el-text-color-primary)}.gold-tab-guide__copy span{font-size:13px;line-height:20px;color:var(--el-text-color-regular)}
.gold-tab-guide__flow{display:flex;align-items:center;justify-content:flex-end;gap:7px;flex-wrap:wrap;color:var(--el-text-color-secondary)}.gold-tab-guide__flow span{padding:4px 9px;border-radius:12px;background:var(--el-bg-color);font-size:12px;white-space:nowrap}.gold-tab-guide__flow .el-icon{flex:0 0 auto}
@media (max-width: 1100px){.gold-tab-guide{align-items:flex-start;flex-direction:column}.gold-tab-guide__flow{justify-content:flex-start}}
</style>
